import { comparisonFeatures } from '@/mocks/seo-content';

export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Why Choose
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            Why Millions Search for Sugargoo Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            See how a structured product database transforms the shopping experience compared to traditional searching.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-background-200/50">
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800">Feature</th>
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-500">Normal Search</th>
                <th className="text-left px-5 py-4 text-sm font-semibold text-primary-600">Sugargoo Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {comparisonFeatures.map((row, idx) => (
                <tr key={row.feature} className={`${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-5 py-3.5 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3.5 text-sm text-foreground-500">{row.normal}</td>
                  <td className="px-5 py-3.5 text-sm text-primary-700 font-medium">{row.spreadsheet}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}